import React from "react";
import BusinessCardRenderer from "./BusinessCardRenderer";
import { BusinessCardProcessPayload } from "../../utils/processData";

interface BusinessCardBodyProps {
  payload: BusinessCardProcessPayload;
  processId?: string;
  isPreview?: boolean;
  className?: string;
}

const BusinessCardBody: React.FC<BusinessCardBodyProps> = ({
  payload,
  processId,
  isPreview = false,
  className = "",
}) => {
  const { userData, businessCardData, entityData, template, settings } =
    payload;

  return (
    <BusinessCardRenderer
      userData={userData}
      businessCardData={businessCardData}
      customerIdentification={entityData?.owner_data?.user_identification || ""}
      entityIdentification={entityData?.entity_identification || ""}
      fallbackTemplate={template}
      processId={processId}
      isPreview={isPreview}
      className={className}
      entityData={{
        entity_name: entityData?.entity_name,
        entity_description: entityData?.entity_description,
        entity_logo: entityData?.entity_logo,
      }}
      entityPreferences={{
        business_card_form: {
          template,
          enableUserRegistration: settings?.enableUserRegistration,
          enableSaveContact: settings?.enableSaveContact,
          showFooter: businessCardData?.showFooter,
        },
        cdn_logo_project_path: entityData?.entity_logo,
      }}
    />
  );
};

export default BusinessCardBody;
